import { ImageStyle, StyledImg } from "./style";
import { ImageProps, Spin } from "antd";
import { isBoolean } from "lodash";

interface IProps extends ImageProps {
  spinning?: boolean;
  allowPreview?: boolean; // = true
}
const CustomImage = (props: IProps) => {
  const { spinning, allowPreview = true, ...restProps } = props;
  return (
    <Spin spinning={spinning || false}>
      {allowPreview ? (
        <ImageStyle
          {...restProps}
          preview={
            isBoolean(restProps.preview)
              ? restProps.preview
              : {
                  ...restProps.preview,
                  mask: (
                    <div
                      style={{
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        fontSize: 10,
                      }}
                    >
                      プレビュー
                    </div>
                  ),
                }
          }
        />
      ) : (
        <StyledImg>
          <img
            loading="lazy"
            src={restProps.src}
            width={restProps.width}
            onClick={(e) => restProps.onClick && restProps.onClick(e)}
          />
          <div
            onClick={(e) => restProps.onClick && restProps.onClick(e)}
            className="mark"
            style={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontSize: 10,
              width: restProps.width,
            }}
          >
            プレビュー
          </div>
        </StyledImg>
      )}
    </Spin>
  );
};

export default CustomImage;
